import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  InputAdornment,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import MaterialUiIconPicker from "react-material-ui-icon-picker";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import TableData from "../../components/TableData";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/miniCrm/knowledgeBase";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  grid: {
    display: "flex",
    alignItems: "center",
  },
});

class KnowledgeBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalAction: false,
      modalDelete: false,
    };
  }
  async componentDidMount() {
    await this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "title", numeric: true, disablePadding: false, label: "Tiêu đề" },
    { id: "icon", numeric: true, disablePadding: false, label: "Icon" },
    { id: "tags", numeric: true, disablePadding: false, label: "Tags" },
    {
      id: "description",
      numeric: true,
      disablePadding: false,
      label: "Miêu tả",
    },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Ngày tạo",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "title":
            case "icon":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListKnowledgeBase({ where: where });
    this.props.getListKnowledgeBase(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {} });
  };

  handleAction = () => {
    const { id } = this.state.item;
    let data = [];
    if (!id) {
      const { title, icon, description, tags } = this.state;
      const newItem = tags.split(",");
      newItem.forEach((element) => {
        data.push(element);
      });
      return (
        this.props.addNewKnowledgeBase(title, icon, description, {
          tags: data,
        }),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      const { id, title, icon, description, tags } = this.state.item;
      const newItem = tags.toString().split(",");
      newItem.forEach((element) => {
        data.push(element);
      });
      return (
        this.props.editKnowledgeBase(id, title, icon, description, {
          tags: data,
        }),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteKnowledgeBase(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  showPickedIcon = (ico) => {
    this.setState({
      icon: ico.name,
    });
  };

  showPickedIconEdit = (ico) => {
    this.setState({
      item: {
        ...this.state.item,
        icon: ico.name,
      },
    });
  };

  render() {
    const { classes, listKnowledgeBase, coutKnowledgeBase } = this.props;
    const { title, icon, description, tags, filters, item, modalDelete } =
      this.state;
    const listKnowledgeBaseResult =
      typeof listKnowledgeBase === "object"
        ? Object.keys(listKnowledgeBase).map((key) => listKnowledgeBase[key])
        : listKnowledgeBase;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={4}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tên tiêu đề"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.title}
                        name="title"
                      />
                    </Grid>
                    <Grid item md={4}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tags"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.tags}
                        name="tags"
                      />
                    </Grid>
                    <Grid item md={4}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách"
          items={listKnowledgeBaseResult}
          rowsPerPage={filters.pageSize}
          count={coutKnowledgeBase.count}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item ? (item.id ? "Chỉnh sửa thông tin" : "Thêm thông tin") : null
          }
          fullwidth={true}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên tiêu đề"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("title")
                          : this.handleChangeText("title")
                        : null
                    }
                    value={item ? (item.id ? item.title : title) : null}
                    name="title"
                    validators={["required"]}
                    emptyLabel="Không được để trống"
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tags"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("tags")
                          : this.handleChangeText("tags")
                        : null
                    }
                    value={item ? (item.id ? item.tags : tags) : null}
                    name="tags"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  <Grid container className={classes.grid}>
                    <Grid item lg={8}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        placeholder="Icon"
                        variant="outlined"
                        className={classes.input}
                        // onChange={!!item ? (item.id ? this.handleChangeTextEdit('icon') : this.handleChangeText('icon')) : null}
                        value={item ? (item.id ? item.icon : icon) : ""}
                        disabled
                        name="icon"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Icon>
                                {item ? (item.id ? item.icon : icon) : ""}
                              </Icon>
                            </InputAdornment>
                          ),
                        }}
                        // validators={["required"]}
                        // errorMessages="Không được để trống"
                        // helperText="Icon theo chuẩn Material UI - https://material.io/tools/icons/?style=baseline"
                      />
                    </Grid>
                    <Grid item lg={1}></Grid>
                    <Grid item lg={3}>
                      <MaterialUiIconPicker
                        onPick={
                          item
                            ? item.id
                              ? this.showPickedIconEdit
                              : this.showPickedIcon
                            : null
                        }
                        label="Chọn Icon"
                        pickLabel="Done"
                      />
                    </Grid>
                  </Grid>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Miêu tả"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("description")
                          : this.handleChangeText("description")
                        : null
                    }
                    value={
                      item ? (item.id ? item.description : description) : null
                    }
                    name="description"
                    multiline
                    rows={5}
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                </Grid>
                <DialogActions>
                  <Button
                    onClick={this.handleClose}
                    color="secondary"
                    className={classes.button}>
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}>
                    Lưu
                  </Button>
                </DialogActions>
              </FormControl>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

KnowledgeBase.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listKnowledgeBase: state.knowledgeBase.knowledgeBases,
  coutKnowledgeBase: state.knowledgeBase.count,
});

KnowledgeBase = connect(mapStateToProps, mapActionsToProps)(KnowledgeBase);

export default withStyles(styles)(KnowledgeBase);
